import {Modal} from "../_classes";
import {Lightbox} from "../_classes";
import {throttle} from "../sf-utils";
import {reference} from "@popperjs/core";
import {delegate} from "tippy.js";
import "tippy.js/animations/shift-away.css";
import "tippy.js/dist/tippy.css";

/**
 * Set up team modal
 * @param {*} modal - Modal instance
 * @param {*} teamMemberID  - Team member ID
 * @returns {boolean}
 */
function setupTeamModal(teamMemberID, modal) {
	if (!teamMemberID) return false; // if no team member ID, return false (close modal)

	const $memberElement = $(`[data-teammember="${teamMemberID}"]`); // get markup for the team member from the main page content
	// if the team member element exists...
	if ($memberElement.length) {
		modal.elements.dialog.team.html($memberElement.html()); // ...duplicate the team member content to the team dialog...
	}
	return Boolean($memberElement.length); // return true if team member element exists (i.e show team member modal)
}

/**
 * Add cancel subscription link to cancel subscription modal
 * @param {string} cancelSubscriptionLink - Cancel subscription link
 * @param {*} modal - Modal instance
 * @returns {boolean}
 */
function addCancelSubscriptionLinkToModal(cancelSubscriptionLink, modal) {
	const $anchorElement = modal.elements.dialog["cancel-subscription"].find(
		"#sf-cancel-subscription-dialog__link"
	);

	const showModal = cancelSubscriptionLink && $anchorElement.length; // check if both cancel subscription link and anchor element exist
	if (showModal) $anchorElement.attr("href", cancelSubscriptionLink); // set the href attribute of the anchor element to the cancel subscription link
	return showModal; // return true if both cancel subscription link and anchor element exist (i.e show cancel subscription modal), otherwise return false (close modal)
}

/**
 * Detect OS and apply it to download modals
 * @param {string} setOS - The OS to set for download modals (optional)
 */
function changeOSforDownloadModals(setOS = null) {
	const detectedOS = (navigator.userAgentData?.platform || navigator.platform)?.toLowerCase(); // Get the detected OS from the browser

	const os =
		setOS && ["mac", "linux", "windows"].includes(setOS.toLowerCase()) // if setOS is provided and is a valid OS...
			? setOS.toLowerCase() // ...set os to the provided OS...
			: detectedOS.startsWith("mac") // ...otherwise, if the detected OS starts with 'mac'...
			? "mac" // ...set os to mac...
			: detectedOS.startsWith("linux") // ...if the detected OS starts with 'linux'...
			? "linux" // ...set os to linux...
			: "windows"; // ...otherwise, set os to windows (default).

	$("[data-downloadlinks]").attr("data-downloadlinks", os); // apply os to download modals
	// if we're setting the OS...
	if (setOS) {
		// ...loops through all the dropdowns in each dialog...
		$("[data-downloadlinksdropdown]").each(function () {
			$(this).val(os); // ...and set the value of each dropdown to the provided OS.
		});
	}
}

/**
 * Toggle checksum instructions for download modals
 */
function initChecksumToggle() {
	$("a[data-checksum]").on("click", function (e) {
		const $instructions = $(this)
			.closest(".sf-download-dialog__link-item")
			.find(".sf-download-dialog__checksum-instructions"); // Find the instructions for this link

		$(".sf-download-dialog__checksum-instructions").not($instructions).slideUp(200); // Hide all other instructions
		$instructions.slideDown(200); // Show this one
	});
}

export function initOverlays() {
	window.sfModal = new Modal({
		team: setupTeamModal,
		"cancel-subscription": addCancelSubscriptionLinkToModal
	}); // init modal

	changeOSforDownloadModals(); // detect & set OS for download modals on first page load
	initChecksumToggle(); // init checksum toggle

	// handle manual changes of OS on download dialogs:
	$(document).on("change", "[data-downloadlinksdropdown]", function () {
		const setOS = $(this).val(); // get the selected value
		changeOSforDownloadModals(setOS); // set OS for download modals
	});

	// if lightbox elements exist...
	if ($("[data-lightbox-content], [data-lightbox]").length) {
		new Lightbox(); // ...init lightbox...

		// ...and init tooltips for lightbox:
		delegate("#js-app", {
			target: "[data-lightbox-content] img[src], [data-lightbox]",
			content: "Click to enlarge",
			theme: "sf-grey",
			arrow: false,
			offset: [0, 5],
			allowHTML: true,
			animation: "shift-away"
		});
	}

	//Show/hide back to top overlay when scrolled over 1vh:
	const backToTop = $("#sf-overlay-back-to-top");
	if (backToTop.length) {
		window.onscroll = throttle(function () {
			backToTop.showHide(window.scrollY >= window.innerHeight);
		}, 200);
	}

	//initiate tooltips:
	delegate("#js-app", {
		target: "[data-tippy-content]",
		theme: "sf-grey",
		arrow: false,
		offset: [0, 5],
		allowHTML: true,
		animation: "shift-away"
	});
	delegate("#js-app", {
		target: "[data-tippy-green-content]",
		content: (reference) => reference.getAttribute("data-tippy-green-content"),
		theme: "sf-green",
		arrow: false,
		offset: [0, 5],
		allowHTML: true,
		animation: "shift-away"
	});
}
